import React from 'react';

function SectionHeading({ tag, title, description }) {
  return (
    <div className="mb-8 text-center">
      {tag && (
        <span className="text-xs font-bold uppercase tracking-widest text-accent">{tag}</span>
      )}
      <h2 className="mt-2 text-2xl font-black text-white md:text-3xl">{title}</h2>
      {description && (
        <p className="mx-auto mt-3 max-w-2xl text-silver leading-relaxed">{description}</p>
      )}
    </div>
  );
}

export default SectionHeading;
